import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

import reducer from './reducers'

const enhancer = composeWithDevTools(applyMiddleware(thunkMiddleware))

export default createStore(reducer, enhancer)
